import React, { useEffect } from "react";
import { IoClose } from "react-icons/io5";

const MsVahanModal = ({
  title,
  isOpen,
  handleIsOpenModal,
  handleIscloseModal,
  children,
  trigger,
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    // Clean up
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  return (
    <>
      {isOpen && (
        <>
          <div
            className="modal-msVahan-overlay fixed inset-0 bg-black bg-opacity-50 z-50 p-5"
            onClick={handleIscloseModal}
          ></div>
          <div
            // For debugging or fix:
            className="modal-msVahan-content fixed bg-white h-[95vh] w-full max-w-[98vw] md:max-w-[95vw] lg:max-w-[1200px] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 rounded-md p-4 overflow-y-auto"
          >
            <div className="flex flex-col gap-4">
              <div className="flex items-center justify-between">
                <p className="text-sm font-semibold">{title}</p>
                <div
                  className="p-2 rounded-md border cursor-pointer hover:bg-[#28526e] hover:text-white"
                  onClick={handleIscloseModal}
                >
                  <IoClose />
                </div>
              </div>
              <div>{children}</div>
            </div>
          </div>
        </>
      )}
      {trigger}
    </>
  );
};

export default MsVahanModal;
